import { useReducer } from "react"

import { TextField, Box, IconButton } from "@mui/material";
import { lockedReducer } from '../../utils/defaultReducer'

import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

const EditableTitle = ({ key, title, editable, onChange, automationItem, moreOptionsItem, placeholder = 'Clique para nomear', maxLength = 30, className = 'editable-title-header', multiline = false, minRows = 1, maxRows }) => {

    const [state, setState] = useReducer(lockedReducer, {
        title: title,
        edit: false
    })

    return (
        <>
            {
                !state.edit ?
                    <>
                        <Box
                            className={className}
                            onClick={() => { if (editable) setState({ edit: true }) }}>
                            {state.title ? state.title : placeholder}
                        </Box>
                        <Box>
                            {automationItem}
                            {moreOptionsItem}
                        </Box>
                    </>
                    :
                    <>
                        <TextField

                            variant='standard'
                            size='small'
                            multiline={multiline}
                            minRows={minRows}
                            maxRows={maxRows}
                            value={state.title}
                            onChange={({ target }) => setState({ title: target.value })}
                            inputProps={{
                                maxLength: maxLength
                            }}
                            sx={{ background: 'white', padding: '.25rem' }}
                        />
                        <IconButton onClick={() => setState({ edit: false, title: title })}><CloseIcon /></IconButton>
                        <IconButton onClick={() => {
                            setState({ edit: false }); onChange(state.title)
                        }}><CheckIcon /></IconButton>
                    </>
            }
        </>
    )
}

export default EditableTitle